import Vue from 'vue'
import axios from 'axios'
// import './assets/responsive'
import './assets/iconfont.css'
import './assets/global.css'


import App from './App.vue'
import router from './router'
import '@/router/permission' // 权限控制器
import store from './store'
// 注册全局过滤器
import filter from '@/utils/filter'
Object.keys(filter).forEach(key => Vue.filter(key, filter[key]));
// 页面缓存
import Navigation from 'vue-navigation'
Vue.use(Navigation, { router, store, keyName: 'VNK' })

// 按需引入element ui
import { Select ,Option,RadioGroup,RadioButton,Timeline, TimelineItem,Switch} from 'element-ui';
import '@/theme/index.css'
Vue.use(Select).use(Option).use(RadioGroup).use(RadioButton).use(Timeline).use(TimelineItem).use(Switch)

// 按需引入vant
import { Calendar,IndexBar, IndexAnchor} from 'vant';  
import 'vant/lib/index.css'
Vue.use(Calendar).use(IndexBar).use(IndexAnchor)

// 引入mandMobile 
import mandMobile from 'mand-mobile'
import 'mand-mobile/lib/mand-mobile.css'
import '@/theme/mand-index.css'
import '@/theme/mand-font-reset.css'
Vue.use(mandMobile)

// 重置主题样式
import './assets/resetTheme.css'

// 播放音频 传入要转的文字
Vue.prototype.$playaudio = audio
Vue.prototype.$setLEDText = function(){}

// 引入echart
// import echarts from 'echarts'
// Vue.prototype.$echarts = echarts

Vue.prototype.$http = axios;

// cookie设置为全局
import Cookies from "@/utils/Cookies";
Vue.prototype.$Cookies = Cookies

Vue.config.productionTip = false


new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')



// 返回按钮
document.addEventListener('plusready', function () {
    

    Vue.prototype.$setLEDText = setLEDText
    function setLEDText(text) {
        text = text || '欢迎光临'
        var result = plus.bridge.execSync('sunmiLED','LEDSEND',[text])
    }
    var webview = plus.webview.currentWebview();
    plus.key.addEventListener('backbutton', function () {
        webview.canBack(function (e) {
            if (e.canBack) {
                webview.back();
            } else {
                var first = null;
                plus.key.addEventListener('backbutton', function () {
                    //首次按键，提示‘再按一次退出应用’
                    if (!first) {
                        first = new Date().getTime();
                        console.log('再按一次退出应用');
                        setTimeout(function () {
                            first = null;
                        }, 1000);
                    } else {
                        if (new Date().getTime() - first < 1500) {
                            plus.runtime.quit();
                        }
                    }
                }, false);
            }
        })
    });
    // 获取相机权限
    plus.android.requestPermissions(['android.permission.CAMERA'], function (e) { }, function (e) {
        alert('Request Permissions error:' + JSON.stringify(e));
    });
});



// if ('addEventListener' in document && 'ontouchstart' in window) {
//     FastClick.prototype.focus = function (targetElement) {
//         targetElement.focus()
//     }
//     document.addEventListener('DOMContentLoaded', function () {
//         FastClick.attach(document.body)
//     }, false)
// }


function audio(text) {
    new Audio( "http://tts.baidu.com/text2audio?lan=zh&ie=UTF-8&ctp=10&per=5118&text=" + text ).play();
}